import { useEffect, useRef, useState } from 'react';
import './chat.css';
import { AnimatePresence, LayoutGroup, motion } from "motion/react"
import { X } from 'react-feather';
import toast from 'react-hot-toast';
import { get, getDatabase, off, onValue, push, ref } from 'firebase/database';

function Chat({user,app}) {
  
  const [isOpen,setIsOpen] = useState();
  const form = useRef();
  const scroll = useRef();
  const input = useRef();
  const [messages, setMessages] = useState();
  const [loading, setLoading] = useState();
  const [isAdmin,setIsAdmin] = useState(false);
  const [currentChat,setCurrentChat] = useState('');
  const [chatList,setChatList] = useState([]);

  useEffect(()=>{
    if(isAdmin){
      get(ref(getDatabase(app), `messages`)).then((snapshot) => {
        if (snapshot.exists()) {
          const users = Object.keys(snapshot.val());
          setChatList(users);
          setCurrentChat(users[0]);
        }
      });
    }
  },[isAdmin])
  useEffect(()=>{
    if(user.uid == 'uBk8L2rh21OhREHLwRw9GrVqKqr2'){
      setIsAdmin(true)
    }
    else{
      setIsAdmin(false)
    }
  },[user])
  const open = ()=>{
    if(!user){
      toast.error('You need to sign in to access the exercises!')
      return;
    }
    setIsOpen(true)
  }
  const sendMessage = (e)=>{
    if(loading){
      return;
    }
    setLoading(true)
    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData(form.current);
    const message = formData.get('message');
    if(!message)
      return false;
    push(ref(getDatabase(app),'messages/'+(currentChat?currentChat:user.uid)),{
            created:new Date().getTime(),
            text:message,
            isMe:isAdmin?false:true
          }).then(ok => {
            input.current.value = '';
            setLoading(false)
          }).catch(console.error);
        
    return false;

  }
  useEffect(()=>{
    scroll.current?.scrollTo(0, scroll.current?.scrollHeight);
  },[messages])
  const close = (e)=>{
      if(e.keyCode==27)
        setIsOpen(false);
    }
    useEffect(()=>{
      if(!isOpen || !app || !user){
        return;
      }
      const messagesRef = currentChat?ref(getDatabase(app), 'messages/' + currentChat):ref(getDatabase(app), 'messages/' + user.uid);

      const unsubscribe = onValue(messagesRef, (snapshot) => {
        
        if(!snapshot.exists()){
          return;
        }
        const data = snapshot.val();
        setMessages(data);
      })

      return ()=>{
        off(messagesRef , "value", unsubscribe);
      }
    },[app,isOpen, user,currentChat])
    useEffect(()=>{
    document.addEventListener('keyup',close)
      return ()=>{
        document.removeEventListener('keyup',close);
      }
    },[])
  return (
    <motion.div
    transition={{type:'spring',bounce:.25,duration:.5}}
    drag={isOpen?'y':''}
  dragConstraints={{ top: 0,bottom:0 }}
dragElastic={{top:0,bottom:.4}}
onDragEnd={(e,i)=>{
  if(i.offset.y > 50){
    setIsOpen(false)
  }
}}
    style={isOpen?{

    borderTopLeftRadius:20,
    borderTopRightRadius:20,
    borderBottomLeftRadius:0,
    borderBottomRightRadius:0,
    bottom:0,
    top:80,
    left:0,
    right:0
    }:{
      bottom:20,
      right:20,
      borderTopLeftRadius:40,
    borderTopRightRadius:40,
    borderBottomLeftRadius:40,
    borderBottomRightRadius:40,
    }} layout className='chatContainer'>
      {!isOpen?
      <div className='chatClick' onClick={open}>
        <img src="/emmanuel.jpg"/> Ask Emmanuel
      </div>:
      <div className='chatContent'>
        <div className='overlay' onClick={()=>setIsOpen(false)}></div>
        <div className='chatTitle'>
          {chatList.length?
        <select onChange={(e)=>{setCurrentChat(e.target.value)}}>
          {chatList.map((c,i)=><>
            <option key={c} defaultChecked={i==0?true:false} value={c}>{c}</option>
            </>
          )}
        </select>  
        :<>
          <img src="/emmanuel.jpg"/> Ask Emmanuel <span onClick={()=>setIsOpen(false)}><X/></span></>}
        </div>
        <div className='chatMessages' ref={scroll}>
          <LayoutGroup>
          {
             !messages?<></>:Object.values(messages)?.map(m=>
              <AnimatePresence key={'animate'+m.created}>
               <motion.div initial={{opacity:0,scale:0}} animate={{opacity:1,scale:1}} layout key={m.created} className={isAdmin&&m.isMe?'chatMessageContainer':isAdmin?'chatMessageContainer me':m.isMe?'chatMessageContainer me':'chatMessageContainer'}>
          <div className='chatMessage'>{m.text}</div>
          </motion.div>
          </AnimatePresence>
            )
          }
          </LayoutGroup>
        </div>
        <form ref={form} className='chatInput' onSubmit={sendMessage}>
          <input disabled={loading?true:false} ref={input} type='text' name='message' placeholder='Ask something'/>
        </form>
      </div>
      }
    </motion.div>

  );
}

export default Chat;